/*
 * @Author: 张斌
 * @Date: 2022-04-08 10:05:58
 * @LastEditors: 张斌
 * @LastEditTime: 2025-06-26 18:02:28
 */

// list=[
//   {
//     type:'template',
//     text:'温湿度',
//     log:[
//       {
//         time:'2022-04-08 10:05:58',
//         child:[  {
//         childtype:'temperature',
//         childtext:'温度',
//         content:'1'
      
//       },
//       {
//         childtype:'humidity',
//         childtext:'湿度',
//         content:'2'
//       }
//     ]


//       }
//     ]

//   },
//   {
//     type:'pm',
//     text:'PM2.5',
//     log:[
//       {
//         time:'2022-04-08 10:05:58',
//         child:[ {
//         childtype:'pm1',
//         childtext:'PM1',
//         content:'1'
//        },
//        {
//         childtype:'pm2',
//         childtext:'PM2.5',
//         content:'2'
//        },
//        {
//         childtype:'pm10',
//         childtext:'PM10',
//         content:'3'
//        }]

//       }
//     ]

//   },
//   {
//     type:'',
//     text:'风力等级',
//     log:[
//       {
//         time:'2022-04-08 10:05:58',
//        child:[{
//           childtype:'wind',
//           childtext:'风力等级',
//           content:'1'
//         }]
//       }
//     ]

//   }
// ]


import {baseApi, baseMqttUrl} from './config/index.js'
export default {
  // /** 接口地址 */
  // apiBaseUrl: 'https://api.szh1tech.com/V1', // 正式线
  // apiBaseUrl: 'https://api.szh1tech.com:4388/V1', // 正式线
    
  apiBaseUrl: baseApi|| process.env.VUE_APP_API_URL,
  apiBaseMqttUrl: baseMqttUrl|| process.env.VUE_APP_API_URL_MQTT,

  // apiBaseUrl: 'http://192.168.15.250:8088/V1',   // 测试线
  // apiBaseUrl: 'http://192.168.1.245:8088/V1',  // 本地线
  // apiBaseUrl: 'http://120.79.100.207:8093/V1', // 本地线
  // apiBaseUrl: 'http://47.115.32.181:8088/V1',  // 本地线
  // apiBaseUrl: 'http://192.168.1.28:8088/V1',  // 本地线
  // apiBaseUrl: 'http://10.192.27.252:8088/V1',// 本地线c
}
